import React from 'react'
import { withRouter } from 'react-router-dom'

import { PageTitle } from 'Components/PageTitle'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { CityAddEditWrapper } from 'Components/City/CityAddEdit/Wrapper'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { PATHS } from 'Config/Routing/paths'
import CitiesIcons from 'Assets/Images/icons/cities'
import { CreateCityView } from '../../Form/City/CityAddEdit/CreateCityView'
import StyledBreadcrumbs from '../../../Components/StyledBreadcrumbs'

const CityAdd = props => (
  <HideWhenBlocked>
    <CityAddEditWrapper>
      <LayoutDashboard>
        <div>
          <StyledBreadcrumbs
            icon={<CitiesIcons style={{ width: 16 }} />}
            breadcrumbs={[
              {
                label: 'Cities',
                link: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
              },
              {
                label: 'Create',
              },
            ]}
          />
        </div>
        <PageTitle>Create City</PageTitle>
        <CreateCityView {...props} />
      </LayoutDashboard>
    </CityAddEditWrapper>
  </HideWhenBlocked>
)

export default withRouter(CityAdd)
